import { RentContractImpl } from '~/stores/rent-event-store/rent-contract/rent-contract.impl';
import type { RentContractInitParams } from '~/stores/rent-event-store/rent-contract/rent-contract.interface';

export default class RentContract extends RentContractImpl {
  constructor(params: RentContractInitParams) {
    super(params);
  }
}
